import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcNewClock = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 72,
	height: 72,
	viewBox: "0 0 72 72",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.7024 43.6513C11.7024 56.991 22.5808 67.805 36 67.805C49.4192 67.805 60.2976 56.991 60.2976 43.6513C60.2976 30.3116 49.4192 19.4976 36 19.4976C22.5808 19.4976 11.7024 30.3116 11.7024 43.6513Z",
			fill: "#DFE3EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M29.9059 12.2252C29.5543 11.4204 29.3594 10.5323 29.3594 9.59898C29.3594 5.95447 32.3315 3 35.9977 3C39.6639 3 42.636 5.95447 42.636 9.59898C42.636 10.5323 42.4411 11.4204 42.0895 12.2252C42.4123 12.3752 42.636 12.7009 42.636 13.0786V15.595C42.636 16.1149 42.212 16.5364 41.6889 16.5364H39.4617V18.5337C51.9075 20.2128 61.5 30.8183 61.5 43.651C61.5 57.6509 50.0833 69 36 69C21.9167 69 10.5 57.6509 10.5 43.651C10.5 30.896 19.9767 20.3413 32.3127 18.5651V16.5364H30.3065C29.7834 16.5364 29.3594 16.1149 29.3594 15.595V13.0786C29.3594 12.7009 29.5831 12.3752 29.9059 12.2252ZM31.674 12.1371H40.3214C40.7641 11.3935 41.0182 10.5257 41.0182 9.59898C41.0182 6.84265 38.7705 4.6082 35.9977 4.6082C33.225 4.6082 30.9772 6.84265 30.9772 9.59898C30.9772 10.5257 31.2313 11.3935 31.674 12.1371ZM59.0952 43.651C59.0952 30.9714 48.7551 20.6926 36 20.6926C23.2449 20.6926 12.9048 30.9714 12.9048 43.651C12.9048 56.3306 23.2449 66.6095 36 66.6095C48.7551 66.6095 59.0952 56.3306 59.0952 43.651Z",
			fill: "#CED2DA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.2706 57.3783L38.2718 43.5957L33.8038 43.6219L35.787 57.378C35.8271 57.6557 36.2302 57.6559 36.2706 57.3783Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.8012 29.2285L33.8012 43.1991L38.2692 43.1729L36.2849 29.2287C36.2453 28.9504 35.8411 28.9502 35.8012 29.2285Z",
			fill: "#F2F4F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.6266 43.1391C33.7115 41.7985 34.8736 40.7801 36.2223 40.8645C37.571 40.9489 38.5954 42.1042 38.5105 43.4448C38.4256 44.7855 37.2634 45.8039 35.9148 45.7195C34.5661 45.6351 33.5416 44.4798 33.6266 43.1391Z",
			fill: "#CED2DA"
		})
	]
});
export default SvgIcNewClock;
